export enum ClientType {
    Standard = 0,
    Catalog = 1,
    Fleet = 2,
}